import React, {MouseEvent, useEffect, useMemo, useState} from 'react';
import styles from './Preparations.module.scss';
import RightIcon from '@assets/icons/chewron_right.svg?react';

import { Content, Lesson } from '@types';
import SectionContents from '../lesson/lesson-section/section-contents/SectionContents';
import { LessonType, LastVisitedLessonContentFragment } from '@api/graphql-codegen';

type Props = {
  title: string;
  contents: Content[] | undefined;
  lesson: Lesson | undefined;
  lessonType: LessonType | undefined;
  lessonOpened: boolean;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
};

function Preparations(props: Props) {
  const { title, contents = [], lesson, lessonOpened, lastVisitedLesson } = props;

  const [opened, setOpened] = useState(true);

  useEffect(() => {
    if (lessonOpened) setOpened(true);
  }, [lessonOpened])

  const handleToggle = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    const _opened = !opened;
    setOpened(_opened);
  };

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (opened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [opened]);
  
  return (
    <div className={wrapperClassName}>
      <div onClick={handleToggle} className={styles.header}>
        <RightIcon className={styles.rightIcon}/>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.content}>
        <SectionContents contents={contents} lesson={lesson} lastVisitedLesson={lastVisitedLesson} isPreparation />
      </div>
    </div>
  );
}

export default React.memo(Preparations);
